import { useQuery } from "@tanstack/react-query"
import { apiFetchWeb } from "./apiFetchWeb"

export interface WebsiteConfigData {
  title: string
  description: string
  logo_image: string
  banner_image: string
  footer_description: string | null
  facebook_url: string | null
  instagram_url: string | null
  tiktok_url: string | null
  x_url: string | null
  map_embed_url: string | null
  [key: string]: any
}

export const useWebsiteConfig = () => {
  return useQuery({
    queryKey: ["website-config"],
    queryFn: async () => {
      const response = await apiFetchWeb<WebsiteConfigData>(
        "settings/website-details",
        {
          method: "GET",
        }
      )
      return response
    },
  })
}
